/**
 * Website router utilities
 * Provides route creation for public-facing pages
 */
import { PageSlugs } from "../../add-element/types";
import { PageData, RouteDefinition } from "./types";

/**
 * Creates route definitions from page data
 * Used by website.js to configure React Router
 *
 * @param pages - Array of page objects with slug property
 * @returns Array of route definitions for React Router
 */
export const createRoutes = (pages: PageData[]): RouteDefinition[] =>
  pages.map(({ slug }) =>
    // The path for Home is '/' rather than '/home'
    ({
      name: slug,
      path: `/${slug === PageSlugs.Home ? "" : slug}`,
    }),
  );
